import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { ApiResponse } from '../api-response.model';
import { CompaniaPaquete, CompanyPackage, Paquete } from 'src/app/shared/model/package';

@Injectable({
  providedIn: 'root',
})
export class CompaniaPaqueteService {
  private baseUrl: string;

  constructor(private http: HttpClient, private config: ApiConfiguration) {
    this.baseUrl = `${this.config.rootUrl}`;
  }

  insertCompanyPackage(payload: CompaniaPaquete): Observable<ApiResponse<CompaniaPaquete>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<ApiResponse<CompaniaPaquete>>(`${this.baseUrl}/compania-paquete`, payload, { headers });
  }

  getActivesByIdCompany(idCompany: string): Observable<ApiResponse<{ packages: CompanyPackage[] }>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<ApiResponse<{ packages: CompanyPackage[] }>>(`${this.baseUrl}/compania-paquete/obtener-compania-activos/${idCompany}`, { headers });
  }

  getAvailableByIdCompany(idCompany: string): Observable<ApiResponse<{ packages: CompanyPackage[] }>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<ApiResponse<{ packages: CompanyPackage[] }>>(`${this.baseUrl}/compania-paquete/obtener-compania-disponibles/${idCompany}`, { headers });
  }

  getById(idPackage: string): Observable<ApiResponse<Paquete>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<ApiResponse<Paquete>>(`${this.baseUrl}/paquete/${idPackage}`, { headers });
  }

  getAllActive(): Observable<ApiResponse<{ packages: Paquete[] }>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<ApiResponse<{ packages: Paquete[] }>>(`${this.baseUrl}/paquete/activos`, { headers });
  }

  activate(idCompany: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.patch<any>(`${this.baseUrl}/compania-paquete/activar/${idCompany}`, { headers });
  }
}
